module.exports = __webpack_public_path__ + "static/media/gameStop.c10b70bd.svg";